import React from "react";
import { motion } from "framer-motion";
import { Building2, Users, Store, PartyPopper, Heart, Trophy } from "lucide-react";

const events = [
  { icon: Building2, title: "Eventos Corporativos", desc: "Ativações premium para marcas globais e times executivos.", tag: "B2B" },
  { icon: Users, title: "Feiras", desc: "Aumente o dwell time e engaje visitantes com adrenalina.", tag: "TRADE" },
  { icon: Store, title: "Shopping", desc: "Atrativo perfeito para movimentar o público em datas comerciais.", tag: "RETAIL" },
  { icon: PartyPopper, title: "Aniversários", desc: "Transforme uma comemoração em uma corrida inesquecível.", tag: "FUN" },
  { icon: Heart, title: "Casamentos", desc: "O toque diferente que os convidados vão comentar por anos.", tag: "LOVE" },
  { icon: Trophy, title: "Convenções", desc: "Momento de descompressão de altíssimo padrão para líderes.", tag: "PREMIUM" },
];

export default function Events({ onOpenQuote }) {
  return (
    <section id="eventos" className="relative py-28 md:py-40 bg-[#070707] overflow-hidden" data-testid="events-section">
      <div className="absolute inset-0 opacity-20 carbon-fiber" />
      <div className="relative max-w-[1400px] mx-auto px-6">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#008CFF]" />
            <span className="overline">Aplicações</span>
          </div>
          <h2 className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
            <span className="text-white">ONDE </span>
            <span className="neon-blue">NÓS ATUAMOS</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {events.map((e, i) => (
            <motion.div
              key={e.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.06 }}
              className="group relative rounded-2xl overflow-hidden border border-white/5 bg-gradient-to-br from-[#0c0c0c] to-[#080808] p-8 hover:border-[#E31B23]/40 transition-colors"
              data-testid={`event-card-${i}`}
            >
              <div className="flex justify-between items-start mb-8">
                <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10 group-hover:border-[#E31B23]/60 transition-colors">
                  <e.icon className="w-5 h-5 text-white group-hover:text-[#E31B23] transition-colors" />
                </div>
                <span className="text-[10px] font-mono-tech text-neutral-500 tracking-[0.25em]">{e.tag}</span>
              </div>
              <h3 className="font-display font-black text-2xl text-white leading-tight">{e.title}</h3>
              <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{e.desc}</p>
              <button
                onClick={onOpenQuote}
                className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/80 group-hover:text-[#E31B23] transition-colors"
                data-testid={`event-cta-${i}`}
              >
                Solicitar para este evento →
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
